import {ForkEffect, spawn} from 'redux-saga/effects';
import userSaga from 'App/features/user/userSaga';
import lightProjectsSaga from 'App/features/searchEntities/lightProjects/lightProjectsSaga';

export default function* rootSaga(): Generator<
  ForkEffect<void>,
  void,
  unknown
> {
  yield spawn(userSaga);
  yield spawn(lightProjectsSaga);
}
